import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../colors-v2';
import cl from 'classnames';
import { IconSystemV2CheckBoxTick } from '@doltech/icons/SystemV2/IconSystemV2CheckBoxTick';
import { IconSystemV2EssentialCloseRemoveBold } from '@doltech/icons/SystemV2/IconSystemV2EssentialCloseRemoveBold';

const Container = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 6px;
  border: 1px solid ${colorsV2.neutral40};

  cursor: pointer;

  &:hover {
    border: 1px solid ${colorsV2.neutral140};
  }

  &.selected {
    border: none;
    background: ${colorsV2.blue100};
  }

  &.correct {
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 8px;
    background: ${colorsV2.green100};
  }

  &.wrong {
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 8px;
    background: ${colorsV2.red100};
  }

  &.missed {
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 8px;
    background: ${colorsV2.green100};
  }
`;

export interface QuestionCheckboxProps {
  selected?: boolean;
  state?: 'correct' | 'missed' | 'wrong' | 'default';
}

export const QuestionCheckbox = (props: QuestionCheckboxProps) => {
  const { selected, state = 'default' } = props;

  return (
    <Container className={cl('question-checkbox', state, { selected })}>
      {['wrong'].includes(state) ? (
        <IconSystemV2EssentialCloseRemoveBold size={16} color={colorsV2.white100} />
      ) : (
        <IconSystemV2CheckBoxTick size={state === 'default' ? 16 : 24} />
      )}
    </Container>
  );
};
